import React from 'react';
import { Form } from 'semantic-ui-react';
import Metadata from '../Metadata';

const details = ({ obj, shops, language, onChange }) => {
  return (
    <div>
      <Form.Field>
        <Form.Input
          label="Order"
          type="number"
          placeholder="Order"
          id="order"
          value={
            obj.translations[language.code].order === -1
              ? ''
              : obj.translations[language.code].order
          }
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Date"
          placeholder="Date"
          id="offer_date"
          value={obj.translations[language.code].offer_date}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre"
          id="title"
          value={obj.translations[language.code].title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <Form.Input
          label="Description"
          maxLength="200"
          placeholder="Description"
          id="description"
          value={obj.translations[language.code].description}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Field>
          <Form.Input
            label="CTA - Label"
            placeholder="Label du bouton"
            id="cta_label"
            value={obj.translations[language.code].cta_label || ''}
            onChange={(e) => onChange(e, language.code)}
          />
        </Form.Field>
        <Form.Field>
          <Form.Input
            label="CTA - Url"
            placeholder="URl du bouton"
            id="cta_url"
            value={obj.translations[language.code].cta_url || ''}
            onChange={(e) => onChange(e, language.code)}
          />
        </Form.Field>
      </Form.Group>
      <Metadata obj={obj} language={language} onChange={onChange} />
    </div>
  );
};

export default details;



// WEBPACK FOOTER //
// ./src/components/form/offer/details.js